module.exports = __webpack_public_path__ + "static/media/non-binary__old.803566bb.svg";